var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCutlery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.875.125c-1.023 0-1.79.757-2.305 1.602C1.055 2.57.75 3.572.75 4.5c0 1.614 1.113 2.79 2.5 3.066V14.5H4.5V7.566C5.887 7.291 7 6.114 7 4.5c0-.928-.305-1.929-.82-2.773C5.665.882 4.898.125 3.875.125Zm4.375 0V4.5c0 1.157.8 2.124 1.875 2.402V14.5h1.25V6.902A2.491 2.491 0 0 0 13.25 4.5V.125H12V4.5a1.24 1.24 0 0 1-1.25 1.25A1.24 1.24 0 0 1 9.5 4.5V.125H8.25Zm1.875 0V4.5a.626.626 0 0 0 1.25 0V.125h-1.25Zm-6.25 1.25c.359 0 .84.354 1.23.996.391.642.645 1.502.645 2.129 0 1.252-.781 1.875-1.875 1.875C2.781 6.375 2 5.752 2 4.5c0-.627.254-1.487.645-2.129.39-.642.871-.996 1.23-.996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCutlery);
export default ForwardRef;